import { clearString } from "@/utils/functions";
import api from "../../../settings/api";
import { AxiosResponse } from "axios";
import { Action } from "redux-saga";
import { call, CallEffect, put, PutEffect, SelectEffect, select } from "redux-saga/effects";
import environment from "@/settings/environment";
import { setUser } from "@/redux/ducks/user";
import { setCustomer } from "@/redux/ducks/customer";
import { ReducersTypes } from "@/redux/reducers/Models";

export interface Fetch {
  plate: string;
  token: string;
  callback: (success: boolean, code?: string) => void;
  recaptchaAction?: string;
  isAcceptedTerms?: boolean;
}

export interface AuthAction {
  type: string;
  payload: Fetch;
}

export default function* authorize({
  payload,
}: AuthAction): Generator<
  CallEffect<unknown> | PutEffect<Action> | SelectEffect,
  void,
  AxiosResponse
> {
  try {
    const getUser = (state: ReducersTypes) => state.userReducer;
    const getCustomer = (state: ReducersTypes) => state.customerReducer;
    // @ts-expect-error
    const user: ReducersTypes["userReducer"] = yield select(getUser);
    // @ts-expect-error
    const customer: ReducersTypes["customerReducer"] =
      yield select(getCustomer);

    const data: any = {
      companyIdentification: environment.api.companyIdentification,
      licensePlate: clearString(payload.plate)?.toLocaleUpperCase(),
      channel: environment.api.channel,
      token: payload.token,
      isAcceptedTerms: payload.isAcceptedTerms ?? true,
    };

    if (payload.recaptchaAction) {
      data.recaptchaAction = payload.recaptchaAction;
    }
    const response = yield call(api.post, `/v1/customers/authorize`, data);

    if (response?.data?.data?.code === 0) {
      const newAccessToken = response?.data?.data?.accessToken;

      // Atualiza o token no userReducer (usado no fluxo avulso)
      yield put(
        setUser({
          ...user,
          accessToken: newAccessToken,
        }),
      );

      if (customer?.accessToken) {
        yield put(
          setCustomer({
            accessToken: newAccessToken,
          }),
        );
      }

      yield call(payload.callback, true);
    } else {
      yield call(payload.callback, false, "again");
    }
  } catch (error) {
    yield call(payload.callback, false, "timeout");
  }
}
